<div class="confirm-dialog" [style.maxWidth]="data.maxWidth">
    <button class="close-icon" (click)="onCancel()">×</button>
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-content">
        <p>{{ data.message }}</p>
        <div class="dialog-checkboxes" *ngIf="checkboxes.length > 0">
            <label *ngFor="let cb of checkboxes" class="checkbox-label">
                <input type="checkbox" [(ngModel)]="cb.checked" />
                <span>{{ cb.label }}</span>
            </label>
        </div>
    </div>
    <div class="dialog-actions">
        <button class="confirm-button" [ngClass]="{ 'confirm-button--delete': data.isDelete }" (click)="onConfirm()"> {{
            data.confirmText }}</button>
        <button *ngIf="data.showCancel !== false && data.cancelText" class="cancel-button" (click)="onCancel()">{{
            data.cancelText }}</button>
    </div>
</div>